import Swiper, { A11y, Autoplay, EffectFade, EffectCoverflow, Navigation, Pagination } from 'swiper'

const body  = document.querySelector('body');
const home  = body.classList.contains('home');

if (home) {

    // Slider home
    const homeSlideshow = document.querySelector('.alu .swiper-container') !== null;

    if (homeSlideshow) {
        let nbSlides = document.querySelectorAll('.alu .swiper-container .swiper-slide').length;
        let dataSlideAuto = document.querySelector('.alu .swiper-container').getAttribute('data-slide_auto');
        let dataSlideSpeed = document.querySelector('.alu .swiper-container').getAttribute('data-slide_speed');
        dataSlideSpeed = dataSlideSpeed + '000';

        Swiper.use([ A11y, Autoplay, EffectFade, Navigation, Pagination ]);
        
        let config = {
            grabCursor : 'true',
            speed: 700,
            loop : true,

            effect : 'fade',
            fadeEffect: {
                crossFade: true,
            },

            // Pagination (bullet)
            pagination: {
                el: '.slideshow__pagination',
                type: 'bullets', // default
                clickable: true,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                paginationBulletMessage: 'Aller à la diapositive {{index}}',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },
        }

        if(dataSlideAuto === '1'){
            config.autoplay = {
                delay: dataSlideSpeed,
                disableOnInteraction: false,
            }
        }

        if(nbSlides > 1) {
            let swiperHome = new Swiper('.alu .swiper-container', config);
        }

    }

        // Slider posts
        const postsSlideshow = document.querySelector('.posts .swiper-container') !== null;
                
        if (postsSlideshow) {
            let postsSlides = document.querySelectorAll('.posts .swiper-container .swiper-slide').length;

            Swiper.use([ A11y, EffectFade, Navigation ]);

            let postsConfig = {
                effect : 'slide',
                grabCursor : 'true',
                speed: 700,
                loop : true,
                slidesPerView: 'auto',

                fadeEffect: {
                    crossFade: true
                },

                keyboard: {
                    enabled: true,
                },

                mousewheel: {
                    forceToAxis: true,
                    releaseOnEdges : true, 
                },

                navigation: {
                    nextEl: `.posts .swiper-button-next`,
                    prevEl: `.posts .swiper-button-prev`,
                },
            }

            go();
            window.addEventListener('resize', go);

            function go(){
                if(window.innerWidth > 960){
                    if(postsSlides > 3){
                        let swiperPosts = new Swiper('.posts .swiper-container', postsConfig);
                    }
                }
                else if(window.innerWidth > 640){
                    if(postsSlides > 2){
                        let swiperPosts = new Swiper('.posts .swiper-container', postsConfig);
                    }
                }
                else {
                    if(postsSlides > 1){
                        let swiperPosts = new Swiper('.posts .swiper-container', postsConfig);
                    }
                }
            }

        }

        // Slider kiosque
        const kiosqueSlideshow = document.querySelector('.kiosque .swiper-container') !== null;
                
        if (kiosqueSlideshow) {
            let kiosqueSlides = document.querySelectorAll('.kiosque .swiper-container .swiper-slide').length;

            Swiper.use([ Navigation, EffectCoverflow, A11y ]);

            let kiosqueConfig = {
                effect : 'coverflow',
                grabCursor : 'true',
                speed: 700,
                loop : true,
                slidesPerView: 'auto',

                centeredSlides: true,
                coverflowEffect: {
                    rotate: 0,
                    modifier: 1,
                    slideShadows: false,
                    depth: 180,
                    scale: 1,

                },

                fadeEffect: {
                    crossFade: true
                },

                keyboard: {
                    enabled: true,
                },

                mousewheel: {
                    forceToAxis: true,
                    releaseOnEdges : true, 
                },

                navigation: {
                    nextEl: `.kiosque .swiper-button-next`,
                    prevEl: `.kiosque .swiper-button-prev`,
                },
            }

            if(kiosqueSlides > 1){
                let swiperKiosque = new Swiper('.kiosque .swiper-container', kiosqueConfig);
            }
        }

}
